import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { GKClientDataGrid, Grid2 } from "components";
import dayjs from "dayjs";
import DashboardLayout from "layouts/DashboardLayout";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const Leo = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["leo-wealth-inquiries"],
    queryFn: () => axiosInstance.get(`/api/leo-wealth/inquiry/`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "name", 100, 1),
    },
    {
      ...extraColumnsField("Email", "email", 100, 1),
    },
    {
      ...extraColumnsField("Phone", "phone", 100, 1),
    },
    {
      ...extraColumnsField("Message", "description", 100, 1),
    },
    {
      ...extraColumnsField("Date", "createdOn", 100, 1),
      valueGetter: (row) => dayjs(row?.row?.createdOn).format("DD/MM/YYYY"),
    },
  ];
  return (
    <DashboardLayout title="Leo Wealth Inquiries">
      <Grid2 size={12}>
        <GKClientDataGrid
          columns={columns}
          rows={data?.data || []}
          loading={isLoading}
          showFiltersButton={false}
        />
      </Grid2>
    </DashboardLayout>
  );
};

export default Leo;
